module.exports = __webpack_public_path__ + "1570f7e94c2692ee8be1c8444a26096b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/twitter.png
// module id = 1308
// module chunks = 47